// extracted by mini-css-extract-plugin
export default {"component":"styles_component__w-1y6","card":"styles_card__I12CL"};